import * as $runtime from "../runtime.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Control$dMonad$dMaybe$dTrans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as Record from "../Record/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Util$dHalogen from "../Util.Halogen/index.js";
const $Action = (tag, _1) => ({tag, _1});
const $Query = (_1, _2) => ({tag: "SetItems", _1, _2});
const put = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dMaybe$dTrans.monadStateMaybeT(Halogen$dQuery$dHalogenM.monadStateHalogenM);
  return s => $0.state(v => Data$dTuple.$Tuple(undefined, s));
})();
const pure = /* #__PURE__ */ (() => Control$dMonad$dMaybe$dTrans.applicativeMaybeT(Control$dMonad$dFree.freeMonad).pure)();
const insert = /* #__PURE__ */ Record.insert({reflectSymbol: () => "selected"})()();
const SetItems = value0 => value1 => $Query(value0, value1);
const EnterEdit = /* #__PURE__ */ $Action("EnterEdit");
const LeaveEdit = /* #__PURE__ */ $Action("LeaveEdit");
const Toggle = value0 => $Action("Toggle", value0);
const Receive = value0 => $Action("Receive", value0);
const component = dictEq => (
  {
    initialState: (() => {
      const $0 = Data$dFunctor.arrayMap(insert(Type$dProxy.Proxy)(false));
      return x => ({items: $0(x), isEditMode: false});
    })(),
    render: v => {
      const $0 = v.isEditMode;
      return Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("mx-1 flex")],
        [
          Data$dArray.allImpl(a => !a.selected, v.items) || $0
            ? Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [],
                [
                  Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-plus")], []))("border border-sky-500 text-sky-700 hover:bg-sky-200")(EnterEdit)
                ]
              )
            : Halogen$dVDom$dTypes.$VDom("Text", ""),
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "div",
            [
              Halogen$dHTML$dProperties.class_($0 ? "fixed inset-0 bg-black opacity-20" : "hidden"),
              Halogen$dVDom$dDOM$dProp.$Prop("Handler", "click", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", LeaveEdit)))
            ],
            []
          ),
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "ul",
            [
              Halogen$dHTML$dProperties.class_($0 ? "absolute flex min-w-48 flex-col gap-0.5 bg-white p-4 wrap-anywhere shadow-md" : "flex w-full flex-wrap gap-1 wrap-anywhere"),
              Halogen$dVDom$dDOM$dProp.$Prop("Handler", "click", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", EnterEdit)))
            ],
            Data$dFunctor.arrayMap(item => Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "li",
              [Halogen$dHTML$dProperties.class_(item.selected || $0 ? "min-w-0" : "hidden")],
              [
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "button",
                  [
                    Halogen$dHTML$dProperties.classes([
                      "h-full w-full rounded border px-3 py-1 whitespace-pre-wrap transition-colors duration-75",
                      item.selected ? "border-sky-700 bg-sky-500 text-white hover:bg-sky-600" : "border-gray-800 bg-gray-300 text-black hover:bg-gray-400"
                    ]),
                    (() => {
                      const $1 = $Action("Toggle", item.key);
                      return Halogen$dVDom$dDOM$dProp.$Prop("Handler", "click", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $1)));
                    })()
                  ],
                  [Halogen$dVDom$dTypes.$VDom("Text", item.value)]
                )
              ]
            ))(v.items)
          )
        ]
      );
    },
    eval: Halogen$dComponent.mkEval({
      ...Halogen$dComponent.defaultEval,
      handleAction: v => {
        if (v.tag === "EnterEdit") {
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(undefined, {...s, isEditMode: true})),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.CatNil
          );
        }
        if (v.tag === "LeaveEdit") {
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF(
                "State",
                s => {
                  const s$p = {...s, isEditMode: false};
                  return Data$dTuple.$Tuple(s$p, s$p);
                }
              ),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.$CatList(
              "CatCons",
              v1 => Control$dMonad$dFree.$Free(
                Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF("Raise", Data$dFunctor.arrayMap(v2 => v2.key)(Data$dArray.filterImpl(v2 => v2.selected, v1.items)), undefined),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                ),
                Data$dCatList.CatNil
              ),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "Toggle") {
          const $0 = v._1;
          const $1 = Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF(
                "State",
                s => Data$dTuple.$Tuple(
                  undefined,
                  {
                    ...s,
                    items: Data$dFunctor.arrayMap(item => {
                      if (dictEq.eq(item.key)($0)) { return {...item, selected: !item.selected}; }
                      return item;
                    })(s.items)
                  }
                )
              ),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.CatNil
          );
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.isEditMode, s)),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.$CatList(
              "CatCons",
              b => {
                if (b) { return $1; }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              },
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "Receive") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF(
                "State",
                s => Data$dTuple.$Tuple(
                  undefined,
                  (() => {
                    const $1 = s.items;
                    return {
                      ...s,
                      items: Data$dFunctor.arrayMap(v1 => {
                        const $2 = v1.key;
                        return {
                          key: $2,
                          value: v1.value,
                          selected: (() => {
                            const $3 = Data$dArray.find(x => dictEq.eq(x.key)($2))($1);
                            if ($3.tag === "Nothing") { return false; }
                            if ($3.tag === "Just") { return $3._1.selected; }
                            $runtime.fail();
                          })()
                        };
                      })($0)
                    };
                  })()
                )
              ),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.CatNil
          );
        }
        $runtime.fail();
      },
      handleQuery: x => {
        const $0 = x._2;
        return Control$dMonad$dMaybe$dTrans.bindMaybeT(Control$dMonad$dFree.freeMonad).bind(put({items: x._1, isEditMode: false}))(() => pure($0));
      },
      receive: x => Data$dMaybe.$Maybe("Just", $Action("Receive", x))
    })
  }
);
export {$Action, $Query, EnterEdit, LeaveEdit, Receive, SetItems, Toggle, component, insert, pure, put};
